export default __webpack_public_path__ + "static/media/kalimpong2.236ce6b4.jpg";